import { render, staticRenderFns } from "./QrLink.vue?vue&type=template&id=67078674&scoped=true"
import script from "./QrLink.vue?vue&type=script&lang=js"
export * from "./QrLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67078674",
  null
  
)

export default component.exports